import type { BrandIdentifier } from "../data/appShellTypes";

export interface SurfaceConfig {
  appSlug: string | null;
  brandIdentifier: BrandIdentifier;
  skipSelector: boolean;
  isDedicatedSurface: boolean;
}

const SURFACE_MAP: Record<string, SurfaceConfig> = {
  "developers.joveo.ai": {
    appSlug: "docs",
    brandIdentifier: "joveo",
    skipSelector: true,
    isDedicatedSurface: true,
  },
  "docs.joveo.ai": {
    appSlug: "docs",
    brandIdentifier: "joveo",
    skipSelector: true,
    isDedicatedSurface: true,
  },
  "cortex.joveo.ai": {
    appSlug: null,
    brandIdentifier: "cortex",
    skipSelector: false,
    isDedicatedSurface: false,
  },
  // Enable (partner onboarding/implementation/support) is partner-facing, so it
  // gets the partner sign-in copy like docs — never Cortex branding — and
  // scopes the shell to just the Enable app.
  "enable.joveo.ai": {
    appSlug: "enable",
    brandIdentifier: "joveo",
    skipSelector: true,
    isDedicatedSurface: true,
  },
};

export function detectSurface(): SurfaceConfig {
  const hostname = window.location.hostname;
  const hosted = SURFACE_MAP[hostname];
  // A real Docs/Enable host is authoritative: a stray ?surface= must not make
  // docs.joveo.ai call itself Enable, or the reverse.
  if (hosted?.isDedicatedSurface) {
    return hosted;
  }

  // Elsewhere ?surface= picks the surface. Local development uses it, and so
  // does cortex.joveo.ai: ProtectedRoute/AppGuard send a signed-out visitor to
  // /enable or /docs on to /login?surface=<app>.
  const params = new URLSearchParams(window.location.search);
  const surfaceOverride = params.get("surface");
  if (surfaceOverride === "docs") {
    return SURFACE_MAP["docs.joveo.ai"];
  }
  if (surfaceOverride === "enable") {
    return SURFACE_MAP["enable.joveo.ai"];
  }

  if (hosted) {
    return hosted;
  }
  // Default: full app shell
  return {
    appSlug: null,
    brandIdentifier: "cortex",
    skipSelector: false,
    isDedicatedSurface: false,
  };
}
